import {searchModel} from "../../../../Utilities/Search";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {dynamicSort} from "../../../../Utilities/Sort";

export const aphSearchModel = (userId = "", title = "", catalogNumber = "", minCost = "", maxCost = "", searchTerm = "", availabilityStatus = "") => {
    return Object.assign({}, searchModel(userId.toString(), "itemName", false, "itemName"), {
        title: title,
        catalogNumber: catalogNumber,
        minCost: minCost,
        maxCost: maxCost,
        searchTerm: searchTerm,
        availabilityStatus: availabilityStatus,
        ClearOrderSearch: clearOrderSearch,
        ApplySorting: applySorting,
    });
};

function clearOrderSearch(this: Record<string, unknown>) {
    this.title = "";
    this.catalogNumber = "";
    this.minCost = "";
    this.maxCost = "";
    this.searchTerm = "";
    this.availabilityStatus = "";
    (this as { ClearSearch: (load: boolean) => void }).ClearSearch(false);
}

function applySorting(aphSearchCriteria: Record<string, unknown>, items: Record<string, unknown>[]) {
    if (isNullOrUndefined(items) || isArrayNullOrEmpty(items))
        return items;

    return items.sort(dynamicSort(aphSearchCriteria.sortByColumn as string, aphSearchCriteria.sortDescending as boolean));
}

